import { Button, Icon, Stack, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AccountOnboardingStep, AccountService } from "../../../api/psc";

const OutlinedButton = styled(Button)(({ theme }) => ({
    height: "auto",
    border: "2px solid #424ebc",
    color: "text.primary",
    padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
    backgroundColor: "white",
    "&:hover": {
        backgroundColor: "grey.50",
        border: "2px solid #424ebc",
    },
}));

const ContainedButton = styled(Button)(({ theme }) => ({
    height: "auto",
    border: "2px solid #424ebc",
    color: "white",
    backgroundColor: "#424ebc",
    padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
    "&:hover": {
        backgroundColor: "#424ebc",
        border: "2px solid #424ebc",
    },
}));

export function ActionButtons() {
    const navigate = useNavigate();

    const handleContactUs = () => {
        const contactUs = document.getElementById("contact-us");
        if (contactUs) {
            contactUs.scrollIntoView({ behavior: "smooth" });
            window.location.hash = "#contact-us";
        }
    };

    const handlePlansAndPrices = async () => {
        await AccountService.updateOnboarding("1", {
            step: AccountOnboardingStep.PRICING,
        });
        navigate("/subscriptions");
    };

    const handleDashboard = () => {
        navigate("/");
    };

    return (
        <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={2}
            sx={{ width: "100%" }}
        >
            <OutlinedButton onClick={handleContactUs} fullWidth>
                <Stack spacing={3} alignItems="center">
                    <Icon sx={{ color: "#424ebc", fontSize: "3rem" }}>
                        phone
                    </Icon>
                    <span style={{ fontSize: "1.2rem", whiteSpace: "nowrap" }}>
                        تماس با ما
                    </span>
                </Stack>
            </OutlinedButton>

            <ContainedButton onClick={handlePlansAndPrices} fullWidth>
                <Stack spacing={3} alignItems="center">
                    <Icon sx={{ fontSize: "3rem" }}>credit_card</Icon>
                    <span style={{ fontSize: "1.2rem", whiteSpace: "nowrap" }}>
                        اشتراک‌های پرشین سازه
                    </span>
                </Stack>
            </ContainedButton>

            <OutlinedButton onClick={handleDashboard} fullWidth>
                <Stack spacing={3} alignItems="center">
                    <Icon sx={{ color: "#424ebc", fontSize: "3rem" }}>
                        dashboard
                    </Icon>
                    <span style={{ fontSize: "1.2rem", whiteSpace: "nowrap" }}>
                        داشبورد
                    </span>
                </Stack>
            </OutlinedButton>
        </Stack>
    );
}
